"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SideNav = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _reactRedux = require("react-redux");

var _ThemeConstant = require("../../constants/ThemeConstant");

var _reactCustomScrollbars = require("react-custom-scrollbars");

var _MenuContent = _interopRequireDefault(require("./MenuContent"));

var Sider = _antd.Layout.Sider;

var SideNav = function SideNav(_ref) {
  var navCollapsed = _ref.navCollapsed,
      sideNavTheme = _ref.sideNavTheme,
      routeInfo = _ref.routeInfo,
      hideGroupTitle = _ref.hideGroupTitle,
      _ref$localization = _ref.localization,
      localization = _ref$localization === void 0 ? true : _ref$localization;
  var props = {
    sideNavTheme: sideNavTheme,
    routeInfo: routeInfo,
    hideGroupTitle: hideGroupTitle,
    localization: localization
  };
  return /*#__PURE__*/_react.default.createElement(Sider, {
    className: "side-nav ".concat(sideNavTheme === _ThemeConstant.SIDE_NAV_DARK ? 'side-nav-dark' : ''),
    width: _ThemeConstant.SIDE_NAV_WIDTH,
    collapsed: navCollapsed
  }, /*#__PURE__*/_react.default.createElement(_reactCustomScrollbars.Scrollbars, {
    autoHide: true
  }, /*#__PURE__*/_react.default.createElement(_MenuContent.default, Object.assign({
    type: _ThemeConstant.NAV_TYPE_SIDE
  }, props))));
};

exports.SideNav = SideNav;

var mapStateToProps = function mapStateToProps(_ref2) {
  var theme = _ref2.theme;
  var navCollapsed = theme.navCollapsed,
      sideNavTheme = theme.sideNavTheme;
  return {
    navCollapsed: navCollapsed,
    sideNavTheme: sideNavTheme
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(SideNav);

exports.default = _default;